// extracted by mini-css-extract-plugin
export default {"card":"styles_card__1dAgw","title":"styles_title__LGf2f","text":"styles_text__6Ynzj","button":"styles_button__k0c-Q","iconWrapper":"styles_iconWrapper__XLg-f"};